import type { ServiceMedia } from './types';

export type FeedSlide =
  | { kind: 'video'; url: string; poster?: string }
  | { kind: 'image'; url: string };

/** Ordered slides for the vertical feed: video first (if any), then portfolio photos. */
export function buildFeedSlides(media: ServiceMedia): FeedSlide[] {
  const slides: FeedSlide[] = [];
  if (media.videoURL) {
    slides.push({
      kind: 'video',
      url: media.videoURL,
      poster: media.videoThumbnailURL,
    });
  }
  for (const url of media.photoURLs) {
    slides.push({ kind: 'image', url });
  }
  return slides;
}
